<style lang="scss">
.dashboard {
  .hg-button-enter {
    background-color: $blue;
    color: white;
  }
}

.dark-layout {
  .simple-keyboard {
    background-color: $blue-dark;

    .hg-button {
      background-color: $blue-theme;
      color: white;

      &.hg-button-enter {
        background-color: #1D9BD1;
      }
    }
  }
}
</style>

<template>
  <!-- eslint-disable -->
  <div class="mb-4 dashboard">
    <div class="max-page-width-small mx-auto">
      <h2 class="mb-2 mt-2">Enter your {{ establishmentWord }} number</h2>

      <b-form-input cy="identifier-input" @keyup.enter="keyboardSearch" @input="onPrisonerNumberChange"
                    :placeholder="establishmentWord + ' Number'" v-model="prisonerNumber"></b-form-input>

      <b-card no-body class="mb-0 mt-4">
        <div class="simple-keyboard"></div>
      </b-card>
    </div>

    <b-modal id="rate-call" title="Rate Call" hide-footer>
      <rate-call-modal :visit-id="visitId" @complete="showRateCallModal()"></rate-call-modal>
    </b-modal>

    <b-modal id="sound-check" title="Sound Check" hide-footer>
      <sound-check></sound-check>
    </b-modal>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import { mapState } from 'vuex';
import VisitsService from '@/services/VisitsService';
import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';
import RateCallModal from '@/components/rate-call/RateCallModal.vue';
import SoundCheck from '@/components/soundCheck/SoundCheck.vue';

export default {
  name: 'Dashboard',
  components: {
    RateCallModal,
    SoundCheck,
  },
  props: {
    visitId: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      prisonerNumber: '',
      keyboard: null,
      caps: false,
      calls: [],
      idleTimeAllowed: 15,
      idleTimer: null,
    };
  },
  computed: mapState({
    currentUser: state => state.auth.user,
    establishmentWord() {
      return this.$options.filters.term('prison', true);
    },
  }),
  mounted() {
    this.setUpKeyboard();
    // this.startInactivityTimer();
    // show rate call modal
    if (this.$route.params.visitId) {
      this.showRateCallModal(true);
    }
  },
  beforeDestroy() {
    clearTimeout(this.idleTimer);
  },
  methods: {
    setUpKeyboard() {
      this.keyboard = new Keyboard({
        onChange: inputValue => {
          this.prisonerNumber = inputValue;
        },
        onKeyPress: key => {
          if (key === '{enter}') {
            this.keyboardSearch();
          }

          if (key === '{lock}') {
            this.changeKeyboardLayout();
          }
        },
        layout: {
          default: [
            '1 2 3 4 5 6 7 8 9 0',
            'Q W E R T Y U I O P',
            'A S D F G H J K L',
            'Z X C V B N M',
            '{lock} {bksp} {enter}',
          ],
          shift: [
            '1 2 3 4 5 6 7 8 9 0',
            'q w e r t y u i o p',
            'a s d f g h j k l',
            'z x c v b n m',
            '{lock} {bksp} {enter}',
          ],
        },
        display: {
          '{bksp}': '< BACKSPACE',
          '{enter}': 'SEARCH',
          '{space}': ' ',
          '{lock}': 'Caps',
        },
        buttonTheme: [{
          class: 'osk-enter',
          buttons: '{enter}',
        }],
      });

      this.keyboard.setInput(this.prisonerNumber);
    },
    onPrisonerNumberChange(e) {
      this.keyboard.setInput(e);
    },
    changeKeyboardLayout() {
      this.caps = !this.caps;
      this.keyboard.setOptions({
        layoutName: this.caps ? 'shift' : 'default',
      });
    },
    keyboardSearch() {
      if (this.prisonerNumber && this.prisonerNumber.toUpperCase() === 'SOUNDCHECK') {
        this.showSoundCheckModal(true);
      } else {
        this.getCalls();
      }
    },
    getCalls() {
      VisitsService.getVisits(this.prisonerNumber.trim()).then(res => {
        this.calls = res.data;
        this.sortCallsByStartTime();

        if (this.calls.length === 0) {
          this.showToastError();
        } else {
          // eslint-disable-next-line no-underscore-dangle
          this.$router.push({ name: 'waiting-room', params: { id: this.calls[0]._id } })
        }
      }).catch(err => {
        console.log('Error getting calls ', err);
        this.showToastError();
      }).finally(() => {
        this.loading = false;
      });
    },
    showToastError() {
      this.$toast.error(`We couldn't find any calls booked for the ${this.establishmentWord} number you entered`, {
        toastClassName: ['toast-std', 'warning-toast'],
      });
    },
    sortCallsByStartTime() {
      this.calls.sort((a, b) => {
        const dateA = new Date(a.requested_booking_slot_1.start_date_time);
        const dateB = new Date(b.requested_booking_slot_1.start_date_time);
        return dateA - dateB;
      });
    },
    startInactivityTimer() {
      this.trackIdleTime();
      this.detectUserActivity();
    },
    detectUserActivity() {
      document.addEventListener('click', this.trackIdleTime);
      document.addEventListener('mousemove', this.trackIdleTime);
    },
    trackIdleTime() {
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
      }
      this.idleTimer = setTimeout(() => {
        this.logOutUser();
      }, this.idleTimeAllowed * 1000 * 60);
    },
    logOutUser() {
      this.$store.dispatch('auth/clearLocalUser');
      this.$router.push('/login');
    },
    showRateCallModal(value) {
      if (value) {
        this.$bvModal.show('rate-call');
      } else {
        this.$bvModal.hide('rate-call');
      }
    },
    showSoundCheckModal(value) {
      if (value) {
        this.$bvModal.show('sound-check');
      } else {
        this.$bvModal.hide('sound-check');
      }
    },
  },
};
</script>
